import { UserDTO, UserRoleDTO, UserRoleName } from 'models'
import { AuthPayload, AuthToken } from 'services/api'
// import { noImageAvatar } from '@touche-lts/panel-ui/dist'

const noImageAvatar = 'https://www.securities-services.societegenerale.com/uploads/tx_bisgbio/default-profile.png'

export class User {
  public static get isAuthenticated (): boolean {
    return window.localStorage.getItem('jwt') !== null
  }

  public static authenticate (payload: AuthPayload): void {
    const { accessToken, tokenType, userDetails } = payload
    window.localStorage.setItem(
      'jwt',
      JSON.stringify({ accessToken, tokenType })
    )
    this.setUserDetails(userDetails)
  }

  private static setUserDetails (userDetails: UserDTO): void {
    window.localStorage.setItem('userDetails', JSON.stringify(userDetails))
  }

  public static deauthenticate (): void {
    window.localStorage.clear()
  }

  public static get token (): AuthToken {
    const jwt = window.localStorage.getItem('jwt')
    return jwt ? JSON.parse(jwt) : {}
  }

  private static get details (): UserDTO {
    const userJson = window.localStorage.getItem('userDetails')
    if (userJson) {
      return JSON.parse(userJson)
    }

    return {} as UserDTO
  }

  public static get id (): number {
    const { id } = this.details
    return id || null
  }

  public static get roles (): UserRoleDTO[] {
    const { roles, role } = this.details
    // Backend may return either a `roles` array or a single `role` object
    if (roles && roles.length > 0) return roles
    if (role) return [role]
    return []
  }

  // static getOrganizations (): OrganizationDTO[] {
  //   const { organizations } = this.getDetails()
  //   return organizations || []
  // }

  public static get imageUrl (): string {
    const { imageUrl } = this.details
    return imageUrl || noImageAvatar
  }

  public static get fullName (): string {
    const { firstName, lastName } = this.details
    return `${firstName || ''} ${lastName || ''}`
  }

  // static get organization (): OrganizationDTO {
  //   const organizations = this.getOrganizations()
  //   if (!organizations || !organizations.length) return null

  //   return organizations[0]
  // }

  public static get userRoleNames (): UserRoleName[] {
    return this.roles.map(({ name }) => name)
  }

  public static get isSuperAdmin (): boolean {
    return this.userRoleNames.includes(UserRoleName.SUPER_ADMIN)
  }

  public static get isStoreAdmin (): boolean {
    return this.userRoleNames.includes(UserRoleName.STORE_ADMIN)
  }
}
